/* eslint-disable no-new */

import { Initializer } from '@frds/utilities/src/scripts/init/Initializer';
import { DarkModeToggleSwitch } from './index';

new Initializer('#${prefix}-dark-mode-toggle-switch', [DarkModeToggleSwitch]);
